<template>
  <div>
    <div class="container-fluid">
      <div class="llp-container-section heightcontainer">
        <top-header id="height2"></top-header>
        <main-menu id="height3"></main-menu>
        <div v-if="modifyEmployee == 'Selected'">
          <employee
            id="employee"
            style="padding-left:0px;padding-right:0px"
            @modifiedEmployee="displayAllEmployee"
          ></employee>
        </div>

        <!-- Start the code for this screen here -->
        <div
          v-if="modifyEmployee == 'All'"
          id="employee"
          class="container-fluid menu-margin-top mr-sm-3 mr-lg-0"
          style="z-index:1;padding-left:0px;padding-right:0px"
        >
          <div>
            <nav class="navbar navbar-expand-lg bg-info text-white">
              <span>
                <b>Search for employee</b>
              </span>
            </nav>
            <div class="col d-flex justify-content-end align-items-center">
              <span :style="msgcolor">{{message}}</span>
            </div>

            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2">
              <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                <label id="lnamelaabel" class="col-form-label col-form-label-sm">Last Name</label>
              </div>
              <!--col end-->
              <div
                class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
              >
                <input
                  id="lname"
                  class="form-control input-sm"
                  placeholder="Enter Last Name"
                  v-model.trim="employee.lastName"
                  onkeypress="return (event.charCode > 64 && event.charCode < 91) || (event.charCode > 96 && event.charCode < 123) || event.charCode = 32 || event.charCode = 188"
                />
              </div>
              <!--col end-->
              <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                <label id="regionddlabel" class="col-form-label col-form-label-sm">User Role</label>
              </div>
              <!--col end-->
              <div
                class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
              >
                <select
                  id="regiondd"
                  v-model.trim="employee.roleType"
                  class="form-control input-sm"
                  @[change]="resetremainingfields"
                >
                  <option value>Select a Role...</option>
                  <option value="All">All</option>
                  <option
                    v-for="(option,index) of userroles"
                    :value="option.userRoleC"
                    :key="index"
                  >{{ option.userRoleX }}</option>
                </select>
              </div>
              <!--col end-->
            </div>
            <!--row end-->

            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2">
              <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                <label id="fnamelabel" class="col-form-label col-form-label-sm">First Name</label>
              </div>
              <div
                class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
              >
                <input
                  id="fname"
                  placeholder="Enter First Name"
                  v-model.trim="employee.firstName"
                  class="form-control input-sm"
                  onkeypress="return (event.charCode > 64 && event.charCode < 91) || (event.charCode > 96 && event.charCode < 123) || event.charCode = 32 || event.charCode = 188"
                />
              </div>
              <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                <label id="statusddlabel" class="col-form-label col-form-label-sm">Status</label>
              </div>
              <div
                class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
              >
                <select id="statusdd" v-model.trim="employee.status" class="form-control input-sm">
                  <option
                    v-for="(option,index) of status"
                    :value="option.value"
                    :key="index"
                  >{{ option.text }}</option>
                </select>
              </div>
            </div>
            <br />
            <center class="mb-2">
              <button type="submit" @click="employeesearch" class="btn btn-secondary">Search</button>&nbsp;&nbsp;&nbsp;
              <button
                type="submit"
                @click="resetsearch"
                class="btn btn-secondary"
              >Reset</button>
            </center>

            <div class="row mt-2 justify-content-center">
              <div class="col">
                <div class="table-responsive-sm table-responsive-sm mb-5 tbl-update-dealer">
                  <v-table
                    id="myemployeelistTable"
                    :data="employeeList"
                    class="table table-sm table-bordered table-striped"
                  >
                    <thead class="table-month-header-blue wrap-text" slot="head">
                      <v-th sortKey="firstName">First Name</v-th>
                      <v-th sortKey="lastName">Last Name</v-th>
                      <v-th sortKey="userRoleX">User Type</v-th>
                      <v-th sortKey="inactiveD">Status</v-th>
                      <v-th sortKey="employeeId">Edit</v-th>
                    </thead>
                    <tbody slot="body" slot-scope="{ displayData }">
                      <tr v-for="(entry,index) of displayData" :key="index">
                        <td class="table-month-td">{{entry.firstName}}</td>
                        <td class="table-month-td">{{entry.lastName}}</td>
                        <td class="table-month-td">{{ entry.userRoles.map(role => role.dUserRole.userRoleX).join(', ') }}</td>
                        <td
                          class="table-month-td"
                        >{{entry.inactiveD === null ? 'Active' : 'Inactive'}}</td>

                        <td class="table-month-td text-center">
                          <button
                            type="submit"
                            class="btn btn-secondary btn-edit"
                            :disabled="!checkAccess('updateEmployee')"
                            :class="{'disabled':!checkAccess('updateEmployee')}"
                            @click="viewEmployeeDetails(entry.employeeId)"
                          >Edit</button>
                        </td>
                      </tr>
                    </tbody>
                  </v-table>
                </div>
              </div>
            </div>
            <template v-if="norecordsfound">
              <center>
                <span>
                  <b>No records found</b>
                  <br />
                </span>
              </center>
            </template>
          </div>
        </div>
        <!-- End of the code for this screen here -->
        <bottom-footer></bottom-footer>
      </div>
    </div>
  </div>
</template>
<script>
import TopHeader from '@/components/TopHeader.vue'
import BottomFooter from '@/components/BottomFooter.vue'
import MainMenu from '@/components/Menu.vue'
import Employee from '@/components/Employee.vue'
import httpemployee from '../js/http-employee.js'
import httpcommon from '../js/http-common.js'
import { bus } from '../main'
import { hasAccess } from '../js - Local/permissions.js'
export default {
  components: {
    MainMenu,
    TopHeader,
    Employee,
    BottomFooter
  },
  data () {
    return {
      modifyEmployee: 'All',
      message: '',
      employee: this.createeEmptySearchObject(),
      userroles: [],
      status: [],
      employeeList: [],
      errorslist: [],
      msgcolor: {
        color: 'black'
      },
      norecordsfound: false,
      colheaders: [
        { header: 'SL No#' },
        { header: 'First Name' },
        { header: 'Last Name' },
        { header: 'User Type' },
        { header: 'Status' },
        { header: 'Edit' }
      ],
      userRoleLabels: {
        AD: 'Admin',
        CA: 'Credit Analyst',
        SR: 'Sales Rep',
        BO: 'Back Office'
      }
    }
  },
  methods: {
    displayAllEmployee: function (value) {
      this.modifyEmployee = value
    },
    retrieveData: function () {
      httpcommon
        .get('/userrole/')
        .then(response => {
          this.userroles = response.data
        })
        .catch(e => {
          console.log(e)
          this.errorslist.push(e)
        })
      httpcommon
        .get('/staticdata/status/')
        .then(response => {
          this.status = response.data
        })
        .catch(e => {
          this.errorslist.push(e)
        })
    },
    createeEmptySearchObject () {
      return {
        firstName: '',
        lastName: '',
        roleType: '',
        status: ''
      }
    },
    resetremainingfields: function () {
      if (this.employee.roleType === 'All') {
        this.employee.firstName = ''
        this.employee.lastName = ''
        this.employee.status = ''
      }
    },
    employeesearch: function () {
      if (
        this.employee.firstName.length === 0 &&
        this.employee.lastName.length === 0 &&
        this.employee.roleType.length === 0 &&
        this.employee.status.length === 0
      ) {
        this.message = 'Provide at least one search criteria.'
        this.msgcolor.color = 'Red'
      } else {
        this.message = ''
        this.msgcolor.color = 'Black'
        let searchEmployee = this.createSearchObject()
        httpemployee
          .post('/employee/search/', searchEmployee)
          .then(response => {
            this.employeeList = response.data
            if (this.employeeList.length != 0) {
              this.norecordsfound = false
            } else {
              this.norecordsfound = true
            }
          })
          .catch(e => {
            this.errorslist.push(e)
          })
      }
    },
    viewEmployeeDetails: function (value) {
      this.$store.state.employeeId = value
      bus.$emit('employeeId', value)
      this.modifyEmployee = 'Selected'
    },
    backButton: function (value) {
      this.modifyEmployee = 'All'
    },
    createSearchObject () {
      return {
        firstName: this.employee.firstName,
        lastName: this.employee.lastName,
        roleType: this.employee.roleType == 'All' ? '' : this.employee.roleType,
        statusCode: this.employee.status
      }
    },
    resetsearch () {
      (this.employee = this.createeEmptySearchObject()),
      (this.employeeList = []),
      (this.message = ''),
      (this.norecordsfound = false)
    },
    myFunction () {
      var elmnt = document.getElementById('height2')
      var elmnt1 = document.getElementById('height3')
      var txt = elmnt.offsetHeight
      var width = elmnt.offsetWidth
      var txt1 = elmnt1.offsetHeight
      var ht = txt + txt1
      $('#employee').css('margin-top', txt + txt1 + 3)
    },
    menuheight () {
      var elmnt = document.getElementById('height2')
      var txt = elmnt.offsetHeight
      $('#height3').css('margin-top', txt)
    },
    checkAccess (permission) {
      return hasAccess(permission)
    }
  },
  created () {
    window.addEventListener('resize', this.myFunction)
    window.addEventListener('resize', this.menuheight)
  },
  mounted () {
    this.myFunction()
    this.menuheight()
    this.retrieveData()
    this.employeeList = []
    if(this.$route.query.roleId) {
      this.employee.roleType = this.$route.query.roleId;
      this.employeesearch();
    }
  }
}
</script>
<style scoped>
.btn-edit {
  font-size: 12px;
  padding: 0.2rem 0.75rem;
}

.wrap-text {
  white-space: nowrap;
}
.disabled {
  pointer-events: none;
  cursor: none;
}
</style>
